import React, { useEffect, useState } from "react";
import { capitalizeFirstLetter } from "../../../utils/CapitalizeFirstLetter";
import Swal from "sweetalert2";
import { Spinner } from "react-bootstrap";

export default function DriverInfo({ loc, loadData }) {
  const [loading, setLoading] = useState(false)
  const [address, setAddress] = useState()

  const title = capitalizeFirstLetter(loc?.driver_name)

  async function handleLoadAsync(data) {
    try {
      setLoading(true);
      const loadedData = await loadData(data);
      if (loadedData?.address) {
        setAddress(loadedData?.address)
      }
    } catch (error) {
      return Swal.fire({
        title: 'Ops!',
        text: 'Erro ao buscar dados! Tente novamente mais tarde',
        icon: 'error'
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (loadData) {
      handleLoadAsync(loc)
    }
  }, [loc])
  return (
    <div
      style={{
        padding: "0 10px 10px 10px",
        backgroundColor: "#FFF",
        zIndex: 900000000
      }}
    >
      <div style={{
        maxWidth: "420px",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}>
        {title && <h4>{title}</h4>}

        {loading ?
          <div style={{ width: "100%", display: "flex", justifyContent: "center", overflow: "hidden" }}>
            <Spinner animation="border" role="status" style={{ width: "12px", height: "12px" }}>
              <span style={{ visibility: "hidden" }}>Loading...</span>
            </Spinner>
          </div> :
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            {address && <span style={{ fontSize: "14px" }}><strong>Localização:</strong> {address}</span>}
          </div>}
      </div>
    </div>
  )
}
